import { useCallback } from 'react';
import { BacksolveSourceRow } from 'api';
import normalizeSourceRowsOrder from 'pages/Valuations/approaches/backsolveApproach/SourceRowsTable/normalizeSourceRowsOrder';
import { ExtendedValuationApproachModel } from '../types';

type UseAddSourceDataRowParams = {
  approach: ExtendedValuationApproachModel;
  getSourceRows: () => BacksolveSourceRow[];
  resetSourceRowsSheetWithRows: (rows: BacksolveSourceRow[]) => void;
};

const useAddSourceDataRow = ({
  approach,
  getSourceRows,
  resetSourceRowsSheetWithRows,
}: UseAddSourceDataRowParams) =>
  useCallback(() => {
    const nextRows = normalizeSourceRowsOrder([
      ...getSourceRows(),
      {
        valuation_approach_backsolve: approach.valuations_approach_backsolve.id,
        order: getSourceRows().length + 1,
        title: '',
        date: null,
        source: '',
        size: null,
        price_per_share: '',
        weighting: '',
        source_record_id: null,
      } as BacksolveSourceRow,
    ]);
    resetSourceRowsSheetWithRows(nextRows);
  }, [approach, getSourceRows, resetSourceRowsSheetWithRows]);

export default useAddSourceDataRow;
